(function () {
	const config = {
		indicators: true,
		slideDelay: 3000,
		randomStart: true,
		swipeThreshold: 50
	};

	function initSliders() {
		document.querySelectorAll('.banner-container').forEach(container => {
			initSlider(container);
		});
	}

	function initSlider(container) {
		const elements = {
			container: container,
			items: Array.from(container.querySelectorAll('.banner-item')),
			indicators: null
		};

		const state = {
			currentIndex: 0,
			isPaused: false,
			isFirstRun: true,
			interval: null,
			touchStartX: 0,
			touchEndX: 0,
			isDragging: false
		};

		function setupEventListeners() {
			window.addEventListener('resize', throttle(() => handleResize(elements, state), 100));
			elements.container.addEventListener('mouseenter', () => state.isPaused = true);
			elements.container.addEventListener('mouseleave', () => state.isPaused = false);
			// Touch events
			elements.container.addEventListener('touchstart', handleTouchStart, { passive: true });
			elements.container.addEventListener('touchend', handleTouchEnd);

			// Mouse events
			elements.container.addEventListener('mousedown', handleMouseDown);
			elements.container.addEventListener('mouseup', handleMouseUp);
			elements.container.addEventListener('mouseleave', handleMouseUp);
		}
		function handleTouchStart(e) {
			if (window.innerWidth >= 768) return;
			state.touchStartX = e.changedTouches[0].screenX;
			state.isDragging = true;
			pauseAutoSlide();
		}

		function handleTouchEnd(e) {
			if (!state.isDragging || window.innerWidth >= 768) return;
			state.touchEndX = e.changedTouches[0].screenX;
			handleSwipeGesture();
			state.isDragging = false;
			resumeAutoSlide();
		}

		function handleMouseDown(e) {
			if (window.innerWidth >= 768) return;
			state.touchStartX = e.screenX;
			state.isDragging = true;
			pauseAutoSlide();
		}

		function handleMouseUp(e) {
			if (!state.isDragging || window.innerWidth >= 768) return;
			state.touchEndX = e.screenX;
			handleSwipeGesture();
			state.isDragging = false;
			resumeAutoSlide();
		}

		function handleSwipeGesture() {
			const diff = state.touchEndX - state.touchStartX;

			if (Math.abs(diff) < config.swipeThreshold) return;

			if (diff > 0) {
				// Свайп вправо - предыдущий слайд
				showSlide(state.currentIndex - 1, elements, state);
			} else {
				// Свайп влево - следующий слайд
				showSlide(state.currentIndex + 1, elements, state);
			}
		}

		function pauseAutoSlide() {
			state.isPaused = true;
		}

		function resumeAutoSlide() {
			state.isPaused = false;
		}

		function createIndicators() {
			if (!config.indicators) return;

			const indicatorsContainer = document.createElement('div');
			indicatorsContainer.className = 'indicators-container';

			//indicatorsContainer.className = 'col-12 indicators-container';
			//indicatorsContainer.style.display = 'none';

			elements.indicators = elements.items.map((_, i) => {
				const indicator = document.createElement('div');
				indicator.className = 'indicator';
				indicator.addEventListener('click', () => showSlide(i, elements, state));
				indicatorsContainer.appendChild(indicator);
				return indicator;
			});

			elements.container.appendChild(indicatorsContainer);
			return indicatorsContainer;
		}

		function handleResize() {
			const isMobile = window.innerWidth < 768;

			if (isMobile) {
				initMobileMode(elements, state);
			} else {
				initDesktopMode(elements, state);
			}
		}

		function initMobileMode() {
			stopSlider(state);

			if (state.isFirstRun) {
				if (config.indicators) createIndicators();
				state.currentIndex = config.randomStart ?
					Math.floor(Math.random() * elements.items.length) : 0;
				state.isFirstRun = false;
			}

			showSlide(state.currentIndex, elements, state);

			if (config.indicators) {
				elements.container.querySelector('.indicators-container').style.display = 'flex';
			}

			startSlider(state);
		}

		function initDesktopMode() {
			stopSlider(state);

			elements.items.forEach(item => {
				// Точечный сброс только мобильных стилей
				item.style.position = '';
				item.style.width = '';
				item.style.opacity = '';
				item.style.transition = '';
				item.style.pointerEvents = '';
				item.classList.remove('active');
			});

			if (config.indicators && elements.indicators) {
				const indicatorsContainer = elements.container.querySelector('.indicators-container');
				if (indicatorsContainer) indicatorsContainer.style.display = 'none';
			}
		}

		function showSlide(index) {
			state.currentIndex = (index + elements.items.length) % elements.items.length;

			elements.items.forEach(item => item.classList.remove('active'));
			elements.items[state.currentIndex].classList.add('active');

			if (config.indicators && elements.indicators) {
				elements.indicators.forEach(ind => ind.classList.remove('active'));
				elements.indicators[state.currentIndex].classList.add('active');
			}
		}

		function nextSlide() {
			if (!state.isPaused) {
				showSlide(state.currentIndex + 1, elements, state);
			}
		}

		function startSlider() {
			state.interval = setInterval(nextSlide, config.slideDelay);
		}

		function stopSlider() {
			clearInterval(state.interval);
		}

		setupEventListeners();
		handleResize(elements, state);
	}

	function throttle(fn, delay) {
		let timeout;
		return function () {
			if (!timeout) {
				timeout = setTimeout(() => {
					fn.apply(this, arguments);
					timeout = null;
				}, delay);
			}
		};
	}

	document.addEventListener('DOMContentLoaded', initSliders);
})();